import React, { useState, useEffect } from "react";
import CalculateIcon from "@mui/icons-material/Calculate";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "@mui/material/Button";

import "./WSGRSteps.scss";

const WSGRStep0 = ({ setStep }) => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 2);
    }, 1600);

    return () => clearInterval(interval);
  }, []);

  const handleBeginClick = () => {
    // setStep is now a handler that checks for modal, not direct step setter
    setStep();
  };

  return (
    <div className="ws-gr-step-0">
      <div className="ws-gr-step-0-content">
        <div className="ws-gr-step-0-content-left">
          <div className="ws-gr-step-0-content-left-header">
            <CalculateIcon />
          </div>
          <div className="ws-gr-step-0-content-left-body">
            <div className="ws-gr-step-0-content-left-body-title">
              Follow our rebalance guide
            </div>
            <div className="ws-gr-step-0-content-left-body-description">
              Built for you to make adjustments for your portfolio easily.
            </div>
          </div>
        </div>

        <div className="ws-gr-step-0-content-right">
          <div
            className={`ws-gr-step-0-flow ${activeStep >= 0 ? "active" : ""}`}
          >
            <div className="ws-gr-step-0-flow-number">1</div>
            <div className="ws-gr-step-0-flow-title">Select your portfolio</div>
          </div>

          <div className="ws-gr-step-0-flow-splitter">
            <div className="ws-gr-step-0-flow-splitter-line"></div>
          </div>

          <div
            className={`ws-gr-step-0-flow ${activeStep >= 1 ? "active" : ""}`}
          >
            <div className="ws-gr-step-0-flow-number">2</div>
            <div className="ws-gr-step-0-flow-title">Generate calculation</div>
          </div>
        </div>
      </div>
      <div className="ws-gr-step-footer ws-gr-step-0-footer">
        <Button
          className="ws-gr-step-footer-next-button"
          endIcon={<ArrowForwardIcon />}
          onClick={handleBeginClick}
        >
          Begin
        </Button>
      </div>
    </div>
  );
};

export default WSGRStep0;
